import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './styles.css';

class FormControl extends Component {
  constructor(props) {
    super(props);

    this.input = null;
    this.focus = this.focus.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);

    this.state = {
      focus: false,
    };
  }

  onFocus() {
    this.setState({
      focus: true,
    });
  }

  onBlur() {
    this.setState({
      focus: false,
    });
  }

  focus() {
    if (this.input !== null) this.input.focus();
  }

  render() {
    let label = null;
    if (this.props.label) {
      label = (
        <div className="form-label">
          <span
            className="form-label__text"
            onClick={this.focus}
            onKeyUp={this.focus}
            role="textbox"
            tabIndex="-1"
          >
            {this.props.label}
          </span>
          {this.props.tooltip}
          {this.props.labelButton}
        </div>
      );
    }

    let containerClassName = 'form-group__container';
    let input;
    switch (this.props.type) {
      case 'number':
        input = (
          <input
            className="form-control"
            ref={(element) => { this.input = element; }}
            id={this.props.id}
            disabled={this.props.disabled}
            readOnly={this.props.readOnly}
            name={this.props.id}
            value={this.props.value}
            pattern={this.props.pattern}
            placeholder={this.props.placeholder}
            autoComplete="off"
            type="number"
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onChange={this.props.onChange}
            step={this.props.step}
          />
        );
        break;
      case 'text':
        input = (
          <input
            className="form-control"
            ref={(element) => { this.input = element; }}
            id={this.props.id}
            disabled={this.props.disabled}
            readOnly={this.props.readOnly}
            name={this.props.id}
            value={this.props.value}
            pattern={this.props.pattern}
            placeholder={this.props.placeholder}
            autoComplete="off"
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onChange={this.props.onChange}
            type="text"
          />
        );
        break;
      case 'textarea':
        input = (
          <textarea
            className="form-control"
            ref={(element) => { this.input = element; }}
            id={this.props.id}
            disabled={this.props.disabled}
            readOnly={this.props.readOnly}
            name={this.props.id}
            value={this.props.value}
            pattern={this.props.pattern}
            rows={this.props.rows}
            placeholder={this.props.placeholder}
            autoComplete="off"
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onChange={this.props.onChange}
          />
        );
        break;
      case 'select':
        containerClassName += ' form-group__container--select';
        input = (
          <select
            className="form-control"
            ref={(element) => { this.input = element; }}
            id={this.props.id}
            disabled={this.props.disabled}
            readOnly={this.props.readOnly}
            name={this.props.id}
            value={this.props.value}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onChange={this.props.onChange}
          >
            {this.props.children}
          </select>
        );
        break;
      default:
        input = null;
    }

    if (this.state.focus) containerClassName += ' form-group__container--focus';
    if (this.props.color) containerClassName += ` form-group__container--${this.props.color}`;
    if (this.props.readOnly) containerClassName += ' form-group__container--readOnly';

    return (
      <div className="form-group">
        {label}
        <div className={containerClassName}>
          {this.props.prepend !== null ?
            <div
              className="form-group__prepend"
              onClick={this.focus}
              onKeyUp={this.focus}
              role="textbox"
              tabIndex="-1"
            >
              {this.props.prepend}
            </div>
          : null}
          <div className="form-group__input">
            {input}
          </div>
          {this.props.append !== null ?
            <div className="form-group__append">
              {this.props.append}
            </div>
          : null}
        </div>
      </div>
    );
  }
}

FormControl.propTypes = {
  children: PropTypes.element,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  tooltip: PropTypes.element,
  labelButton: PropTypes.element,
  type: PropTypes.string,
  readOnly: PropTypes.bool,
  value: PropTypes.string,
  pattern: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  step: PropTypes.string,
  rows: PropTypes.string,
  color: PropTypes.string,
  prepend: PropTypes.element,
  append: PropTypes.element,
};

FormControl.defaultProps = {
  children: null,
  id: '',
  disabled: false,
  label: '',
  tooltip: null,
  labelButton: null,
  type: '',
  readOnly: false,
  value: '',
  pattern: '',
  placeholder: '',
  onChange: null,
  step: '1',
  rows: '3',
  color: '',
  prepend: null,
  append: null,
};

export default FormControl;



// WEBPACK FOOTER //
// ./src/components/FormControl/index.jsx